export function Footer() {
  return (
    <footer className="bg-brand-800 text-white mt-auto">
      <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm space-y-2">
        <img
          src="/quickdraw.png"
          alt="Quick Draw Funding"
          className="h-8 mx-auto brightness-0 invert opacity-80"
        />
        <p className="text-brand-300">
          Questions? Contact us at{' '}
          <a href="mailto:support@quickdrawfunding.com" className="text-white hover:underline">
            support@quickdrawfunding.com
          </a>
        </p>
        <p className="text-brand-400 text-xs">
          By submitting this form you agree to our{' '}
          <a href="#" className="text-brand-300 hover:underline">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="#" className="text-brand-300 hover:underline">
            Terms of Service
          </a>
          .
        </p>
        <p className="text-brand-400 text-xs pt-2 border-t border-brand-700">
          &copy; {new Date().getFullYear()} Quick Draw Funding. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
